module.exports = __webpack_public_path__ + "static/sakshi_uppoor-b40092fa31c87f05e9946b4afb81a279.png";